package ru.villawonka.app.data.entity.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import ru.villawonka.app.domain.model.PostSourceDomain

@Serializable
data class PostSourceDto(
    @SerialName("name") val name: String,
    @SerialName("platform") val platform: String,
    @SerialName("post_url") val postUrl: String,
    @SerialName("image_url") val imageUrl: String,
    @SerialName("is_trusted") val isTrusted: Boolean,
)

fun PostSourceDto.toDomain() = PostSourceDomain(
    name = name,
    platform = platform,
    postUrl = postUrl,
    imageUrl = imageUrl,
    isTrusted = isTrusted
)